export function convertAddressToString({ city, street, zipCode }) {
  const formattedStreet = street && (zipCode || city) ? `${street.trim()},` : street
  return [formattedStreet, zipCode, city]
    .filter(Boolean)
    .map(s => s.trim())
    .join(' ')
}
